import { type AccessControlConfig } from '../../../components/AccessControl/accessControl.utils'
import { FeatureToggle } from '../../../contexts/featureToggles/FeatureToggleContext'

export const legacyDepartmentsAccessControl: AccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.RetailerCollectionsDepartmentsAisles],
}